import { MutationHookOptions, useMutation } from '@apollo/client';
import createDepotMutation from './createDepotMutation.graphql';

export const useCreateDepotMutation = (
  options?: MutationHookOptions<
    CreateAccountDepotMutation,
    CreateAccountDepotMutationVariables
  >,
) => {
  return useMutation<
    CreateAccountDepotMutation,
    CreateAccountDepotMutationVariables
  >(createDepotMutation, {
    awaitRefetchQueries: true,
    // Refetch the depot list, plus the account's global contacts since creating
    // a depot may create a new primary contact on the platform account.
    refetchQueries: [
      'ManagedDepotsFromPlatformAccount',
      'ManagedDepots',
      'ManagedPlatformAccountContacts',
    ],
    ...options,
  });
};
